import { Collapse } from "antd";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GradientButton from "./Button/GradientButton";
function CourseMaterial({ selectedCourseData, courseModuleSelectedData }) {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div className="space-y-10">
      {id?.includes("Course") ? (
        <>
          <div className="space-y-10">
            <h1 className="font-semibold">{courseModuleSelectedData?.name}</h1>
            <div className="space-y-5">
              {courseModuleSelectedData?.lessons.map((lesson, i) => {
                return (
                  <Collapse
                    key={i}
                    defaultActiveKey={["1"]}
                    expandIconPosition="end"
                    bordered={false}
                  >
                    <Collapse.Panel
                      header={
                        <p className="font-semibold text-lg">{lesson.name}</p>
                      }
                    >
                      {lesson.items?.map((item, i) => {
                        return (
                          <div key={i} className="flex gap-1 mb-2">
                            <p className="font-semibold">{item.itemType}:</p>
                            <a
                              className="text-orange-600"
                              target="_"
                              href={item.deeplinkUrl}
                            >
                              {item.name}
                            </a>
                          </div>
                        );
                      })}
                    </Collapse.Panel>
                  </Collapse>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <h1 className="font-semibold">{selectedCourseData?.name}</h1>
            {selectedCourseData?.name && (
              <GradientButton
                onClick={() => {
                  navigate(`/courses/${selectedCourseData?.id}`);
                }}
              >
                View Course Details
              </GradientButton>
            )}
          </div>
          <p>{selectedCourseData?.description}</p>
          <div className="flex flex-wrap overflow-auto">
            {selectedCourseData?.instructors?.map((items, i) => {
              return (
                <div
                  key={i}
                  className="w-[50%] flex flex-col items-center text-center gap-2 shadow-shadowOne p-3"
                >
                  <img
                    className="rounded-full w-20 h-w-20"
                    src={items.photoUrl}
                    alt={items.title}
                  />
                  <h1 className="font-semibold">{items.name}</h1>
                  {/* <p>{items.department}</p> */}
                  <p className="text-sm">{items.title}</p>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default CourseMaterial;
